import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import jwt from 'jwt-decode';
// @ts-ignore
import Drawer from 'components/Nav/Drawer';
import Footer from 'components/Nav/Footer';
import Navbar from 'components/Nav/Navbar';
import Tableau from 'components/Tableau';

export const ContentContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box sx={{ py: { xs: 2, sm: 2, md: 0, lg: 0 }, px: { xs: 1, sm: 1, md: 4, lg: 8 } }}>
      <Box py={2}>
        <Navbar />
      </Box>
      {children}
    </Box>
  );
};

export const TuDashboard = ({ userName }: { userName: string }) => {
  return (
    <Box mb={2} style={{ marginTop: '-15px' }}>
      <Typography
        sx={{ fontSize: { xs: '1.8rem', sm: '3rem' } }}
        variant="h3"
        fontWeight="700"
      >
        &lt; {userName} <Typography component="span" color="primary.main" sx={{ fontSize: { xs: '2rem', sm: '3.3rem' } }} variant="h3" fontWeight="700">dashboard</Typography>&gt;
      </Typography>
    </Box>
  );
};

const DashboardIndex = () => {
  const { clientCompany: userName } = jwt(localStorage.getItem('token') as string) as any;
  const tableauToken = localStorage.getItem('tableauToken') as string;

  return (
    <ContentContainer>
      <Drawer>
        <TuDashboard userName={userName} />
        <Tableau src='Summary' token={tableauToken} />
      </Drawer>
      <Footer />
    </ContentContainer>
  );
};

export default DashboardIndex;
